/**
 * The mortal palette — four slots, and for now nothing behind any of them.
 *
 * These exist to prove one thing: that the bottom bar can switch cleanly from
 * the deity's four verbs to a mortal's four and back (`ui/hud.ts`, keyed on
 * the player mode `ui/inhabit.ts` owns). The names are working labels from
 * the inhabitation brief and NOT a locked design — keep them here, data-driven,
 * so that replacing them is an edit to one list.
 *
 * A slot pressed in mortal mode highlights itself in the bar and says so, and
 * does nothing else: no `Simulation.act`, no impulse, no effect on ground,
 * person or beast. This file imports nothing from the simulation on purpose,
 * and `test/inhabit.ts` holds it to that.
 */
export interface MortalVerb {
  /** 1–4, and the key that presses it. */
  slot: 1 | 2 | 3 | 4;
  name: string;
  /** What the bar says when the slot is pressed and there is nothing to do. */
  placeholder: string;
}

export const MORTAL_VERBS: readonly MortalVerb[] = [
  { slot: 1, name: 'take', placeholder: 'take — nothing yet to take' },
  { slot: 2, name: 'use', placeholder: 'use — nothing yet to use' },
  { slot: 3, name: 'speak', placeholder: 'speak — no words yet' },
  { slot: 4, name: 'work', placeholder: 'work — no work yet' },
];

/** `'1'`–`'4'` → the slot, for a key listener. */
export const mortalSlotForKey = (key: string): MortalVerb['slot'] | null => {
  const n = Number(key);
  return n >= 1 && n <= 4 && Number.isInteger(n) ? (n as MortalVerb['slot']) : null;
};
